import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-iowa-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./iowa-state-form.component.html",
  styleUrl: "./iowa-state-form.component.scss",
})
export class IowaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
